
import Vue from 'vue';
import { parse } from 'date-fns';
import { mapActions } from 'vuex';
import PublicPortfolioModal from '~/components/partials/public-portfolio/PublicPortfolioModal.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import PublicPortfolioWorkHistoryForm from '~/components/partials/public-portfolio/PublicPortfolioWorkHistory/PublicPortfolioWorkHistoryForm.vue';
import type { FormState } from '~/types/common';

export default Vue.extend({
  name: 'PublicPortfolioAddWorkHistoryModal',
  components: {
    PublicPortfolioWorkHistoryForm,
    PublicPortfolioModal,
    BravadoButtonV3,
  },
  data(): { formState: FormState } {
    return {
      formState: 'idle',
    };
  },
  computed: {
    isAddButtonDisabled(): boolean {
      if (this.formState === 'error') {
        // @ts-ignore
        return this.$refs.wsForm.$v!.$invalid;
      } else {
        return this.formState !== 'idle';
      }
    },
  },
  methods: {
    ...mapActions('portfolio', ['addWorkHistory']),
    async onSubmit() {
      this.formState = 'idle';

      // @ts-ignore
      if (this.$refs.wsForm.$v.$invalid) {
        this.formState = 'error';
      } else {
        this.formState = 'submitting';
        // @ts-ignore
        const { startMonth, endMonth, startYear, endYear, isCurrentWorkplace, title, company } = this.$refs.wsForm.form;

        try {
          const baseDate = new Date();
          const payload = {
            title,
            public: true,
            current_workplace: isCurrentWorkplace,
            company_id: company.id,
            start_date: parse(`${startMonth}/${startYear}`, 'MMMM/yyyy', baseDate).toString(),
            end_date: '',
            origin: 'seller_portfolio',
          };

          if (!isCurrentWorkplace) payload.end_date = parse(`${endMonth}/${endYear}`, 'MMMM/yyyy', baseDate).toString();

          await this.addWorkHistory(payload);
          this.$modal.hide(this.$constants.dynamicModals.PUBLIC_PORTFOLIO_ADD_WORK_HISTORY_MODAL);
          this.$notice.success('Work history added');
        } catch (e) {
          this.$notice.error('Could not add work history. Try again later');
          this.$sentryUtils.error(e);
        } finally {
          this.formState = 'idle';
        }
      }
    },
  },
});
